import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import ThirdPartyAuth from "AppComponents/ThirdPartyAuth";

export default class MicrosoftPickerChooser extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
    multiselect: PropTypes.bool,
    disabled: PropTypes.bool,
    shouldStopPropagation: PropTypes.bool,
  };

  static defaultProps = {
    multiselect: false,
    disabled: false,
    shouldStopPropagation: true,
  };

  constructor(props) {
    super(props);
  }

  successCallback = ({ accessToken }) => {
    const { updateAccessToken } = this.props;
    if (updateAccessToken) {
      updateAccessToken({ accessToken });
    }

    //picker visble
  };

  updateThirPartyAuthRef = ref => {
    const { setInnerPickerRef } = this.props;
    // TODO: remove the wrappedInstance as it will be deprecated soon
    const authRef = _.get(ref, "refs.wrappedInstance", {});
    this.authPopUpRef = authRef;
    if (setInnerPickerRef) {
      setInnerPickerRef(authRef);
    }
  };

  onAuthClick = e => {
    const { shouldStopPropagation } = this.props;
    if (shouldStopPropagation) e.stopPropagation();

    if (this.props.disabled) {
      return null;
    }

    if (this.authPopUpRef) {
      this.authPopUpRef.onAuthClick();
    }
  };

  render() {
    const { children, classStyle: classStyleName } = this.props;
    return (
      <div onClick={this.onAuthClick} className={classStyleName}>
        <ThirdPartyAuth
          serviceType="MICROSOFT"
          ref={this.updateThirPartyAuthRef}
          onSuccessCallBack={this.successCallback}
        />
        {children ? children : <button>Open Microsoft chooser</button>}
      </div>
    );
  }
}
